module.exports = __webpack_public_path__ + "media/chom-rom kon chôp mĕe.df2d7b9c.mp3";